/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Voice_SoftInputs */

const en_settings_voice_soft = /** @type {(inputs: Settings_Voice_SoftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soft`)
};

const es_settings_voice_soft = /** @type {(inputs: Settings_Voice_SoftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suave`)
};

/**
* | output |
* | --- |
* | "Soft" |
*
* @param {Settings_Voice_SoftInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_voice_soft = /** @type {((inputs?: Settings_Voice_SoftInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Voice_SoftInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_voice_soft(inputs)
	return en_settings_voice_soft(inputs)
});